import React, { useEffect, useState, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { CFormSwitch, CTableDataCell, CTableRow } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import { updateMetaData } from '../../../../Redux/Actions/metaDataAction'
import { isEmpty, checkPermissions } from 'src/views/utils/helper'
import { dispatchAlert } from 'src/Redux/Actions/authAction'
import { GlobalContext } from '../../../context/GlobalState'
import { PERMISSIONS } from '../../../utils/permissions'

const MetadataCollapse = ({ index, info, handleEdit, subCategoriesData }) => {
  const [visible, setVisible] = useState(false)
  const [subCategories, setSubCategories] = useState([])
  const dispatch = useDispatch()

  const { userSessionObj } = useContext(GlobalContext)

  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.META_DATA.UPDATE,
  )
  const handleStatus = async (info) => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))

    let res = await dispatch(updateMetaData('system', info._id, { status: !info.status }))

    if (res?.success) {
      dispatch({ type: 'REFRESH_DATA' })
    } else {
      console.log('failed')
    }
  }

  useEffect(() => {
    mapSubCategory()
  }, [subCategoriesData])

  const subCategoryFlag = !isEmpty(subCategories)

  const mapSubCategory = () => {
    // eslint-disable-next-line array-callback-return
    const subCategoryList = []

    subCategoriesData.forEach((ele) => {
      const { categories } = ele
      categories.forEach((id) => {
        if (id === info._id) {
          subCategoryList.push(ele.name)
        }
      })
    })
    setSubCategories(subCategoryList.filter((item) => item !== '').join(', '))
  }

  let description =
    info.description && info.description.length > 120
      ? `${info.description.slice(0, 110)}...`
      : info.description

  return (
    <>
      <CTableRow align="middle">
        <CTableDataCell className="">{index + 1}</CTableDataCell>
        <CTableDataCell className="">
          <div
            style={{ cursor: `${subCategoryFlag ? 'pointer' : ''}` }}
            className="d-flex align-items-center"
            onClick={() => setVisible(!visible)}
          >
            {subCategoryFlag && (
              <FontAwesomeIcon
                className="mx-1"
                icon={visible ? faCaretRight : faCaretDown}
                size="sm"
              />
            )}
            <p style={{ marginLeft: `${subCategoryFlag ? '' : '1rem'}` }} className="mt-3">
              {info.name}
            </p>
          </div>
        </CTableDataCell>
        <CTableDataCell>
          <p>{description}</p>
        </CTableDataCell>
        <CTableDataCell>
          <p>{info.priority}</p>
        </CTableDataCell>

        <CTableDataCell>{moment.utc(info.created_date).format('DD-MM-YYYY')}</CTableDataCell>

        <CTableDataCell>
          <CFormSwitch
            label={info.status ? 'Active' : 'Disabled'}
            valid={info.status}
            checked={info.status}
            onChange={() => handleStatus(info)}
            size="lg"
          />
        </CTableDataCell>
        <CTableDataCell>
          <CIcon
            icon={cilPencil}
            style={{ cursor: 'pointer' }}
            size="lg"
            title="Edit Plan"
            onClick={() => handleEdit(info)}
          />
        </CTableDataCell>
      </CTableRow>
      {subCategoryFlag && visible && (
        <CTableRow>
          <CTableDataCell colSpan="6" className="px-3">
            <p>{`Sub-Category : ${subCategories}`}</p>
          </CTableDataCell>
        </CTableRow>
      )}
    </>
  )
}

export default MetadataCollapse
